export enum ProjectTone {
  NOT_SPECIFIED = 'not_specified',
  FORMAL = 'formal',
  INFORMAL = 'informal',
}
